<template>
  <div :class="'floatBtn'" v-if="!closeFloatBtn">
    <div class="box toTop" @click="toTop">
      <div class="icon" style="font-size: 25px; text-align: center; width: 100%;">↑</div>
      <div>回到顶部</div>
    </div>
    <div v-if="qrCode" class="box wxCode" @mouseover="mouseOver" @mouseleave="mouseLeave">
      <img class="icon" :src="require('@/assets/image/qrcode.svg')" alt="">
      <div>公众号</div>
    </div>
    <transition name="fade">
      <div class="qrCode"  v-show="showQrCode">
        <img @mouseover="mouseOver" @mouseleave="mouseLeave"  :src="qrCode" alt="">
      </div>
    </transition>
    <div class="box contact" @click="$router.push({path: href})">
      <img class="icon" :src="require('@/assets/image/chatIcon.png')" alt="">
      <div>联系客服</div>
    </div>
  </div>

</template>

<script>
export default {
  name: "FloatChatIcon",
  data() {
    return {
      closeFloatBtn: false,
      showQrCode: false,
      // href: (this.$isMobile ?  '/index/mPersonCenter/feedback' : '/index/pcPersonCenter/feedback'),
      href: '/pages/userCenter/UserCenter/FeedBack',
      timeout: undefined,
      qrCode: require('@/assets/image/HeaderIndex/qr.jpg')
    }
  },
  mounted() {
    if(window.localStorage.getItem('isApp')==="1"){
      this.closeFloatBtn=true;
    }
  },
  updated() {
    console.log(window.localStorage.getItem('isApp'))
    if(window.localStorage.getItem('isApp')==="1"){
      this.closeFloatBtn=true;
    }
  },
  methods: {
    toTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    mouseOver() {
      clearTimeout(this.timeout)
      this.showQrCode = true
    },
    mouseLeave() {
      /* eslint-disable */
      this.timeout = setTimeout(_ => {this.showQrCode = false}, 0)
    }
  }
}
</script>

<style lang="less" scoped>
.floatBtn{
  * {
    margin: 0;
    padding: 0;
  }
  position: fixed;
  bottom: 160px;
  right: 10px;
  z-index: 1;
  .box {
    height: 55px;
    width: 55px;
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    .icon {
      margin-top: 10%;
      width: 40%;
    }
    &.toTop {
      background-color: #f8af17;
      &:hover {
        background-color: #ff9108;
      }
    }
    &.wxCode {
      background-color: #53b368;
      &:hover {
        background-color: #2ba245;
      }
    }
    &.contact {
      background-color: #4f8fda;
      &:hover {
        background-color: #2676d3;
      }
    }
    &.socialReportCustom {
      //background-color: cornflowerblue;
      //background-color: plum;
      //background-color: #2a7cdc;
      background-color: #a94442;
      //background-color: #67C23A;
    }
  }
  .qrCode {
    position: absolute;
    top: 0px;
    right: 65px;
    box-shadow: 0px 0px 10px grey;
    img {
      width: 150px;
    }
  }

}
</style>